import { useEffect, useRef } from 'react';
import { emit } from '@/lib/events';
import { useChoroplethStore } from '@/features/choropleth';
import { useFiltersStore } from './store';
import { useFilteredComuni } from './useFilteredComuni';
import { isFilterActive, F_DEFAULTS } from './filter-fns';
import type { Filters } from './types';

function countActiveFilters(f: Filters): number {
  if (!isFilterActive(f)) return 0;
  let n = 0;
  if (f.alt_min !== F_DEFAULTS.alt_min || f.alt_max !== F_DEFAULTS.alt_max) n++;
  if (f.t_jul_max !== null) n++;
  if (f.t_jan_min !== null) n++;
  if (f.hum_max !== null) n++;
  if (f.snow_min !== null) n++;
  if (f.sunny_min !== null) n++;
  if (f.zones.size > 0) n++;
  if (f.pop_max !== null) n++;
  if (f.hosp_max !== null) n++;
  return n;
}

// Emits 'filter:applied' to lib/events with full context (layer + matched count).
// Mounted once per page (FiltersPanel). Skips initial render.
export function useEmitFilterApplied(): void {
  const applied = useFiltersStore((s) => s.applied);
  const activeLayer = useChoroplethStore((s) => s.activeLayer);
  const { matched } = useFilteredComuni();
  const skipFirst = useRef(true);

  useEffect(() => {
    if (skipFirst.current) {
      skipFirst.current = false;
      return;
    }
    emit('filter:applied', {
      active_filter_count: countActiveFilters(applied),
      layer: activeLayer,
      matched_count: matched,
    });
  }, [applied, activeLayer, matched]);
}
